"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultColumnChartOptions = void 0;
var defaultColumnChartOptions = {
  chart: {
    type: 'column'
  },
  title: false,
  xAxis: {
    title: false,
    labels: {
      enabled: false
    }
  },
  yAxis: {
    title: false,
    labels: {
      enabled: false
    },
    stackLabels: {
      enabled: true,
      useHTML: true
    },
    gridLineWidth: 0,
    tickAmount: 0,
    tickLength: 0,
    plotLines: [{
      width: 1,
      value: 0,
      zIndex: 99
    }]
  },
  plotOptions: {
    series: {
      enableMouseTracking: false
    },
    column: {
      stacking: 'normal',
      pointWidth: 53,
      dataLabels: {
        enabled: false
      },
      enableMouseTracking: false
    }
  },
  legend: {
    enabled: false
  },
  tooltip: {
    enabled: false
  },
  credits: false
};
exports.defaultColumnChartOptions = defaultColumnChartOptions;